import request, { FormDataHeader } from '@/utils/request'
import {
  InvoiceItem,
  getInvoiceCompanyListQuery,
  getInvoiceTxpayerNoQuery,
  getInvoiceTxpayerNoResult,
  saveInvoiceParameter,
  saveInvoiceResult,
  getAreaInfoQuery,
  AreaItem,
  saveAddressParams,
  saveAddressResult,
  userAddressItem,
} from '@/types/invoice'

export function getUserInvoiceList(): Promise<InvoiceItem[]> {
  return request.get(`/api-invoice/wechat/mall/invoice/index`)
}
export function removeInvocie(params: { guid: string }): Promise<void> {
  return request.post('/api-invoice/wechat/mall/invoice/delete_invoice', params, {
    headers: FormDataHeader,
  })
}
export function getInvoiceCompanyList(params: getInvoiceCompanyListQuery): Promise<string[]> {
  return request.get(`/api-v2/common/index/credit_list`, { params })
}
export function getInvoiceCreditDetail(
  params: getInvoiceTxpayerNoQuery
): Promise<getInvoiceTxpayerNoResult> {
  return request.get('/api-v2/common/index/credit_detail', { params })
}
export function saveInvoice(params: saveInvoiceParameter): Promise<saveInvoiceResult> {
  return request.post('/api-invoice/wechat/mall/invoice/save_invoice', params, {
    headers: FormDataHeader,
  })
}
export function getAreaInfo(params?: getAreaInfoQuery): Promise<AreaItem[]> {
  return request.get('/api-invoice/common/area/areas', { params })
}
export function saveUserAddressInfo(params: saveAddressParams): Promise<saveAddressResult> {
  return request.post('/api-invoice/wechat/account/address/save', params, {
    headers: FormDataHeader,
  })
}

export function getUserAddressList(): Promise<userAddressItem[]> {
  return request.get('/api-invoice/wechat/account/address/address_list')
}
export function removeAddress(params: { guid: string; type: number }): Promise<void> {
  return request.get('/api-invoice/wechat/account/address/delete', { params })
}
